export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AIChatResponseEvent: ['AIChatTextDelta', 'AIChatTextUpdate'],
    AutoCheckFeedbackItemPrimitiveProperties: [
      'AutoCheckFeedbackItem',
      'AutoCheckFeedbackItemBase',
    ],
    CalendarEventMoment: [
      'CalendarEventMomentDate',
      'CalendarEventMomentDateTime',
    ],
    FieldValueBase: ['Field', 'FillRecordTemplateApplyFormField'],
    FormulaOutput: [
      'FormulaOutputAlert',
      'FormulaOutputRecordTaskFeeInputValue',
      'FormulaOutputUser',
      'FormulaOutputWorkflowTemplate',
    ],
    RecordTaskFeeInputValue: [
      'RecordTaskFeeInputQuantity',
      'RecordTaskFeeInputText',
    ],
    ViewDataElement: [
      'ViewDataElementBoolean',
      'ViewDataElementCompany',
      'ViewDataElementCurrencyCents',
      'ViewDataElementDate',
      'ViewDataElementDateTime',
      'ViewDataElementDuration',
      'ViewDataElementEntity',
      'ViewDataElementFeeSchedule',
      'ViewDataElementFeeType',
      'ViewDataElementFieldType',
      'ViewDataElementFile',
      'ViewDataElementFileOnRecordType',
      'ViewDataElementGeneralLedgerNumberType',
      'ViewDataElementInspectionTemplate',
      'ViewDataElementMoment',
      'ViewDataElementNumber',
      'ViewDataElementOrganization',
      'ViewDataElementOrganizationFinixMerchantType',
      'ViewDataElementPaymentMethodType',
      'ViewDataElementPaymentTransferType',
      'ViewDataElementRecord',
      'ViewDataElementRecordActionRequiredBy',
      'ViewDataElementRecordPlansSet',
      'ViewDataElementRecordTaskGroupType',
      'ViewDataElementRecordTaskInspectionResult',
      'ViewDataElementRecordTaskInspectionStatus',
      'ViewDataElementRecordTaskPaymentStatusType',
      'ViewDataElementRecordTaskStatus',
      'ViewDataElementRecordTaskType',
      'ViewDataElementRecordTemplate',
      'ViewDataElementRecordTypeApplicationGroup',
      'ViewDataElementRecordTypeStatus',
      'ViewDataElementRecordTypeType',
      'ViewDataElementSettlement',
      'ViewDataElementString',
      'ViewDataElementSurveyResponseRating',
      'ViewDataElementSurveyType',
      'ViewDataElementUser',
      'ViewDataElementUserType',
      'ViewDataElementViolation',
      'ViewDataElementViolationStatus',
      'ViewDataElementViolationType',
    ],
  },
}
export default result
